const mutations = {
    setServiceRequestLabors(state, data) {
        state.serviceRequestLabors = data;
    },
    setServiceRequestLabor(state, data) {
        state.serviceRequestLabor = data;
    }
}

export default mutations;